import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { UPDATE_WS } from "./actionTypes";
import { updateWorkstationSuccessful, updateWorkstationFailed } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationsAPI = getWorkstationsAPI();

// Is user register successfull then direct plot user in redux.
function* updateWS({ payload: { ws, history } }) {
  try {
    console.log("WS", ws);
    const response = yield call(
      workstationsAPI.updateWorkstation,
      ws.name,
      ws.new_name,
      ws.new_timepicking,
      ws.new_type,
      ws.new_wsBuffer,
      ws.new_maxTasks,
      ws.new_inboundArea,
      ws.new_strategyInbound,
      ws.new_outsideConfirmation,
      ws.positions,
      ws.token
    );
    yield put(updateWorkstationSuccessful(response.message));
  } catch (error) {
    yield put(updateWorkstationFailed(error));
  }
}

export function* watchWSUpdate() {
  yield takeEvery(UPDATE_WS, updateWS);
}

function* updateWSSaga() {
  yield all([fork(watchWSUpdate)]);
}

export default updateWSSaga;
